import * as AuthActions from './auth.actions';
import * as PasswordsActions from './passwords.actions';
import * as UserProfilesActions from './user-profiles.actions';

export { AuthActions, PasswordsActions, UserProfilesActions };

export * from './auth.actions';
export * from './passwords.actions';
export * from './user-profiles.actions';
